// extracted by mini-css-extract-plugin
module.exports = {"input":"v_input_input__3ixgX"};